<template lang="pug">
.margin-medium-top(v-if="isTeqGroup")
    app-display(
      label="Tipo cadastrante:",
      :content="tipoCadastrante"
    )
    div.padding(
      v-if="isAssociacaoJuridicamenteConstituida || isEntidadeRepresentativa",
      key="associacaoEntidade"
    )
      el-row
        el-col(:span="12")
          app-display(
            label="Razão social:",
            :content="cadastrantePessoaJuridica.razaoSocial",
            :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouRazaoSocial ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="CNPJ:",
            :content="cadastrantePessoaJuridica.cnpj",
            :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouCNPJ ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="E-mail:",
            :content="cadastrantePessoa.email || '-'",
            :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouEmail ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="Telefone(s):",
            :content="cadastrantePessoa.telefones ? cadastrantePessoa.telefones.toString() : '-'",
            :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouTelefones ? 'text': '' "
          )
      app-divider(label="Endereço")
        app-endereco.paddingEndereco(:endereco="cadastrante.pessoa.endereco", slot="body",:mudouEndereco="compararTeqGroup.mudouPessoa.mudouEndereco")
          div(
            v-if="isAssociacaoJuridicamenteConstituida",
            key="associacao"
          )
    div(
      v-if="cadastrante.representantes && cadastrante.representantes.length > 0"
      key="entidade"
    )
      div
        h3(:class="compararTeqGroup.mudouRepresentanteLegal ? 'text' : 'titulo' ") Representantes
      app-collapse(
        collapsed="1"
        v-for="representante in cadastrante.representantes",
        :key="representante.id",
        :title="representante.pessoa.pessoaFisica.nome"
        :class = "compararTeqGroup && compararTeqGroup.mudouRepresentanteLegal.mudouPessoa.mudouNome ? 'text': '' "
      )
        app-display(
          label="CPF:",
          :content="representante.pessoa.pessoaFisica.cpf",
          :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouCPF ? 'text': '' "
        )
        app-display(
          label="RG:",
          :content="representante.pessoa.pessoaFisica.rg",
          :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouRG ? 'text': '' "
        )
        app-display(
          label="Cargo/Função:",
          :content="representante.cargoFuncao",
          :class = "compararTeqGroup && compararTeqGroup.mudouPessoa.mudouRG ? 'text': '' "
        )

    div(
      v-if="isOficioPresidente",
      key="oficio"
    )
      p.margin-top(v-html="cadastrante.despacho")

    div(
      v-if="cadastrante.membrosComunidade && cadastrante.membrosComunidade.length > 0"
      key="membros"
    )
     div
      h3(:class="compararTeqGroup.mudouMembroComunidade ? 'text' : 'titulo' ") Cadastrantes
      app-collapse(
        v-for="membroComunidade in cadastrante.membrosComunidade",
        :title="membroComunidade.pessoa.pessoaFisica.nome",
        :key="membroComunidade.id",
        collapsed="1"
      )
        app-display(
          label="CPF:",
          :content="membroComunidade.pessoa.pessoaFisica.cpf",
        )
        app-display-multiple(
          label="Telefone(s):",
          :content="membroComunidade.pessoa.listaTelefones || membroComunidade.pessoa.telefones || '-'"
        )
        app-display(
          label="E-mail:",
          :content="membroComunidade.pessoa.email",
          :marginBottom="true"
        )
        app-collapse(
          collapsed="1",
          v-if="showMembroEndereco"
          title="Endereço",
          :showBorder="true",
        )
          app-endereco.padding(:endereco="membroComunidade.pessoa.endereco")
        listagem-documentos(
          v-if="membroComunidade.documentos && membroComunidade.documentos.length > 0"
          :documentos="membroComunidade.documentos",
          :idCadastroOriginal="cadastroOriginal.id",
          :protocoloCadastroOriginal="cadastroOriginal.protocolo",
          ownerDocumento="MEMBROS_DA_COMUNIDADE",
          :idMembroComunidade="membroComunidade._id"
          :class = "compararTeqGroup && compararTeqGroup.mudouMembroComunidade.mudouDocumentos ? 'text': '' "
          :versaoCadastro = "versaoCadastro"
        )
    div(v-if="cadastrante.tipo === ''")
      app-display(
        label="Nome do Cadastrante:",
        :content="cadastrante.nomeCadastrante",
        :marginBottom="true"
      )
      app-display(
        label="CPF do Cadastrante:",
        :content="cadastrante.cpfCadastrante",
        :marginBottom="true"
      )
      app-display(
        label="É funcionário do ITERMA?  ",
        :content="cadastrante.funcionarioIterma ? 'Sim' : 'Não'" ,
        :marginBottom="true"
      )
      app-display(
        label="Nome do Terceirizado:",
        :content="cadastrante.nomeTerceirizado ? cadastrante.nomeTerceirizado : '-'",
        :marginBottom="true"
      )
      app-display(
        label="CPF do Terceirizado:",
        :content="cadastrante.cpfTerceirizado ? cadastrante.cpfTerceirizado : '-'",
        :marginBottom="true"
      )
</template>

<script>
import _ from 'lodash'
import AppDisplay from '..//AppDisplay'
import AppDisplayMultiple from '../AppDisplayMultiple'
import AppEndereco from './InformacoesEndereco'
import AppDivider from '../AppDivider'
import ListagemDocumentos from '../informacoesCadastro/ListagemDocumentos'
import AppCollapse from '@/components/AppCollapse'

export default {

  components: {
    AppDisplay,
    AppDisplayMultiple,
    AppEndereco,
    AppDivider,
    ListagemDocumentos,
    AppCollapse
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: false
    },
    cadastrante: {
      type: Object,
      required: false
    },
    showMembroEndereco: {
      type: Boolean,
      default: false
    },
    compararTeqGroup: {
      type: Object,
      required: false
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },

  data () {
    return {
      representanteId: null,
      membroId: null
    }
  },

  computed: {
    isAssociacaoJuridicamenteConstituida () {
      return this.cadastrante.tipo === 'ASSOCIACAO_JURIDICA_CONSTITUIDA'
    },
    isEntidadeRepresentativa () {
      return this.cadastrante.tipo === 'ENTIDADE_REPRESENTATIVA'
    },
    isOficioPresidente () {
      return this.cadastrante.tipo === 'DE_OFICIO_DO_PRESIDENTE'
    },
    cadastrantePessoa () {
      return this.cadastrante.pessoa
    },
    cadastrantePessoaJuridica () {
      return this.cadastrantePessoa.pessoaJuridica
    },
    tipoCadastrante () {
      let tipo
      switch (this.cadastrante.tipo) {
        case 'ASSOCIACAO_JURIDICA_CONSTITUIDA':
          tipo = 'Associação Juridicamente Constituída'
          break
        case 'ENTIDADE_REPRESENTATIVA':
          tipo = 'Entidade Representativa'
          break
        case 'MEMBROS_DA_COMUNIDADE':
          tipo = 'Membros da Comunidade'
          break
        case 'DE_OFICIO_DO_PRESIDENTE':
          tipo = 'De Ofício do Presidente'
          break
        default:
          tipo = ''
      }
      return tipo
    },
    isTeqGroup () {
      if (!this.cadastrante) {
        return true
      }
      return this.cadastroOriginal.tipo === 'TEQ' ||
        this.cadastroOriginal.tipo === 'PEAS' ||
        this.cadastroOriginal.tipo === 'PEAEX'
    }
  },

  created () {
    if (this.cadastrante.representantes) {
      this.representanteId = this.cadastrante.representantes.length > 0 ? _.cloneDeep(this.cadastrante.representantes).pop().id : null
    }
    if (this.cadastrante.membrosComunidade) {
      this.membroId = this.cadastrante.membrosComunidade.length > 0 ? _.cloneDeep(this.cadastrante.membrosComunidade).pop().id : null
    }
  }

}
</script>

<style scoped lang="scss">

  .label-format {
    font-size: 16px;
    padding-top: 50px;
    margin-bottom: 50px;
  }

  .cadastrante-header {
    color: #444444;
    cursor: pointer;
    font-weight: bold;
    font-size: inherit;
    margin-bottom: 1vh;
  }

  p.despacho {
    font-weight: bold;
  }

  .padding {
    padding-top: 0px;
  }

  .paddingEndereco {
    padding-top: 10px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }

  .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/TeqGroup.vue